import { useEffect, useState } from "react";
import { formatCurrency } from "../../util";

const CategoryBudgetTableContainer = ({ label, content }) => {
  const [totalArr, setTotalArr] = useState(content.map((item) => item.amount));

  useEffect(() => {
    setTotalArr(content.map((item) => item.amount));
  }, []);

  return (
    <>
      {content.length > 0 && (
        <div className="mt-6 w-full ">
          <h5 className="mb-2 font-medium  text-text-1/90 ">{label}</h5>
          <div className="w-full ">
            <table className="w-full">
              <thead>
                <tr className="bg-bkg">
                  <td className="p-1 py-2 bg-gray-600 text-text-gen px-2">
                    No
                  </td>
                  <td className="p-1 py-2 bg-gray-600 text-text-gen ">
                    Description
                  </td>

                  <td className="p-1 py-2 bg-gray-600 text-text-gen  text-right">
                    Amount
                  </td>
                </tr>
              </thead>
              <tbody>
                {content.map((item, index) => (
                  <tr key={index}>
                    <td className="p-1 px-2">{++index}</td>
                    <td className="p-1">{item.name}</td>
                    <td className="p-1 text-center">
                      {formatCurrency(item.amount)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td className="font-bold text-base px-2 p-1" colSpan={2}>
                    Total
                  </td>
                  <td className="font-bold text-base text-right p-1">
                    {formatCurrency(
                      totalArr.reduce((acc, item) => item + acc, 0)
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryBudgetTableContainer;
